import { render, staticRenderFns } from "./billingDeadlineRule.vue?vue&type=template&id=21af17e5&scoped=true&"
import script from "./billingDeadlineRule.vue?vue&type=script&lang=ts&"
export * from "./billingDeadlineRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af17e5",
  null
  
)

export default component.exports